import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Wrap(props) {
  var children = props.children,
      className = props.className,
      columns = props.columns,
      compact = props.compact,
      mobileCollapsed = props.mobileCollapsed,
      center = props.center,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "columns", "compact", "mobileCollapsed", "center"]);

  var classes = classNames(className, 'o2-wrap', {
    'o2-wrap--compact': compact,
    'o2-wrap--mobile-collapsed': mobileCollapsed,
    'o2-wrap--center': center
  });
  var content = children;

  if (content && columns) {
    content = React.Children.map(content, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child) && child.type.displayName === 'O2WrapItem' && !child.props.columns) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread({
          columns: columns
        }, child.props));
      }

      return child;
    });
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }), content);
}

O2Wrap.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  columns: PropTypes.number,
  compact: PropTypes.bool,
  mobileCollapsed: PropTypes.bool,
  center: PropTypes.bool
};
export default O2Wrap;